import { httpClient } from '../../http/httpClient';
export const deleteSalesCopilotThread = threadId => {
  return httpClient.delete(`hub/gpt/v1/threads/${threadId}`);
};
export const getSalesCopilotThreads = () => {
  return httpClient.get('hub/gpt/v1/threads');
};
export const getSalesCopilotThreadMessages = threadId => {
  return httpClient.get(`hub/gpt/v1/threads/${threadId}/messages`);
};